import { useQueryFromRemote } from '@flex-packages/remote-hooks';
import '../core/apis/bank-code-controller-api.mjs';
import '../core/apis/business-place-controller-api.mjs';
import '../core/apis/business-place-department-action-controller-api.mjs';
import '../core/apis/business-place-department-controller-api.mjs';
import '../core/apis/business-place-user-action-controller-api.mjs';
import '../core/apis/business-place-user-controller-api.mjs';
import '../core/apis/competency-api-controller-api.mjs';
import '../core/apis/competency-category-api-controller-api.mjs';
import '../core/apis/competency-excel-api-controller-api.mjs';
import '../core/apis/competency-permission-api-controller-api.mjs';
import '../core/apis/competency-search-api-controller-api.mjs';
import '../core/apis/core-user-data-approval-change-api-controller-api.mjs';
import '../core/apis/core-user-data-approval-step-api-controller-api.mjs';
import '../core/apis/core-user-data-approval-thread-api-controller-api.mjs';
import '../core/apis/customer-allowance-controller-api.mjs';
import '../core/apis/customer-attachment-action-controller-api.mjs';
import '../core/apis/customer-attachment-controller-api.mjs';
import '../core/apis/customer-info-controller-api.mjs';
import '../core/apis/customer-signature-controller-api.mjs';
import '../core/apis/department-action-controller-api.mjs';
import '../core/apis/department-controller-api.mjs';
import '../core/apis/department-user-action-controller-api.mjs';
import '../core/apis/department-user-controller-api.mjs';
import '../core/apis/dependent-family-action-controller-api.mjs';
import '../core/apis/dependent-family-attachment-action-controller-api.mjs';
import '../core/apis/dependent-family-attachment-controller-api.mjs';
import '../core/apis/dependent-family-controller-api.mjs';
import '../core/apis/dependent-family-support-controller-api.mjs';
import '../core/apis/discipline-api-controller-api.mjs';
import '../core/apis/education-experience-action-controller-api.mjs';
import '../core/apis/education-experience-controller-api.mjs';
import '../core/apis/employee-record-card-api-controller-api.mjs';
import '../core/apis/image-preset-api-controller-api.mjs';
import '../core/apis/job-group-action-controller-api.mjs';
import '../core/apis/job-group-controller-api.mjs';
import '../core/apis/job-level-action-controller-api.mjs';
import '../core/apis/job-level-controller-api.mjs';
import '../core/apis/job-rank-action-controller-api.mjs';
import '../core/apis/job-rank-controller-api.mjs';
import '../core/apis/job-rank-new-action-controller-api.mjs';
import '../core/apis/job-role-action-controller-api.mjs';
import '../core/apis/job-role-controller-api.mjs';
import '../core/apis/job-role-new-action-controller-api.mjs';
import '../core/apis/job-role-user-action-controller-api.mjs';
import '../core/apis/job-title-action-controller-api.mjs';
import '../core/apis/job-title-controller-api.mjs';
import '../core/apis/job-title-new-action-controller-api.mjs';
import '../core/apis/jurisdiction-controller-api.mjs';
import '../core/apis/language-controller-api.mjs';
import '../core/apis/language-level-controller-api.mjs';
import '../core/apis/pause-support-controller-api.mjs';
import '../core/apis/personnel-appointment-action-controller-api.mjs';
import '../core/apis/personnel-appointment-controller-api.mjs';
import '../core/apis/personnel-appointment-detail-action-controller-api.mjs';
import '../core/apis/personnel-appointment-detail-controller-api.mjs';
import '../core/apis/personnel-appointment-label-api-controller-api.mjs';
import '../core/apis/project-api-controller-api.mjs';
import '../core/apis/signature-file-action-controller-api.mjs';
import '../core/apis/skill-api-controller-api.mjs';
import '../core/apis/training-api-controller-api.mjs';
import '../core/apis/user-apprenticeship-contract-action-controller-api.mjs';
import '../core/apis/user-apprenticeship-contract-controller-api.mjs';
import '../core/apis/user-attachment-action-controller-api.mjs';
import '../core/apis/user-attachment-controller-api.mjs';
import '../core/apis/user-bank-account-action-controller-api.mjs';
import '../core/apis/user-bank-account-controller-api.mjs';
import '../core/apis/user-basic-bundle-action-controller-api.mjs';
import '../core/apis/user-career-api-controller-api.mjs';
import '../core/apis/user-certificate-issuance-history-action-controller-api.mjs';
import '../core/apis/user-certificate-issuance-history-controller-api.mjs';
import '../core/apis/user-certificate-issuance-policy-controller-api.mjs';
import '../core/apis/user-contract-support-controller-api.mjs';
import '../core/apis/user-controller-api.mjs';
import '../core/apis/user-custom-property-action-controller-api.mjs';
import '../core/apis/user-custom-property-bulk-action-controller-api.mjs';
import '../core/apis/user-custom-property-category-controller-api.mjs';
import '../core/apis/user-custom-property-controller-api.mjs';
import '../core/apis/user-custom-property-info-action-controller-api.mjs';
import '../core/apis/user-custom-property-info-controller-api.mjs';
import '../core/apis/user-discipline-api-controller-api.mjs';
import '../core/apis/user-document-action-controller-api.mjs';
import '../core/apis/user-document-file-action-controller-api.mjs';
import '../core/apis/user-document-legacy-controller-api.mjs';
import '../core/apis/user-email-change-action-controller-api.mjs';
import '../core/apis/user-email-controller-api.mjs';
import { updateUserEmployeeBundlePermissionsRemote } from '../core/apis/user-employee-bundle-action-controller-api.mjs';
import '../core/apis/user-employee-controller-api.mjs';
import '../core/apis/user-employee-support-controller-api.mjs';
import '../core/apis/user-employment-contract-action-controller-api.mjs';
import '../core/apis/user-employment-contract-bundle-action-controller-api.mjs';
import '../core/apis/user-employment-contract-controller-api.mjs';
import '../core/apis/user-info-download-action-controller-api.mjs';
import '../core/apis/user-info-download-action-controller-v2-api.mjs';
import '../core/apis/user-language-level-controller-api.mjs';
import '../core/apis/user-leave-of-absence-action-controller-api.mjs';
import '../core/apis/user-leave-of-absence-controller-api.mjs';
import '../core/apis/user-license-controller-api.mjs';
import '../core/apis/user-memo-action-controller-api.mjs';
import '../core/apis/user-memo-controller-api.mjs';
import '../core/apis/user-personal-action-controller-api.mjs';
import '../core/apis/user-personal-bundle-action-controller-api.mjs';
import '../core/apis/user-personal-controller-api.mjs';
import '../core/apis/user-personal-support-controller-api.mjs';
import '../core/apis/user-personnel-appointment-action-controller-api.mjs';
import '../core/apis/user-personnel-appointment-controller-api.mjs';
import '../core/apis/user-public-info-action-controller-api.mjs';
import '../core/apis/user-remark-controller-api.mjs';
import '../core/apis/user-resignation-action-controller-api.mjs';
import '../core/apis/user-resignation-controller-api.mjs';
import '../core/apis/user-restrict-info-action-controller-api.mjs';
import '../core/apis/user-reward-api-controller-api.mjs';
import '../core/apis/user-salary-contract-action-controller-api.mjs';
import '../core/apis/user-salary-contract-controller-api.mjs';
import '../core/apis/user-setting-controller-api.mjs';
import '../core/apis/user-setting-custom-controller-api.mjs';
import '../core/apis/user-setting-meta-controller-api.mjs';
import '../core/apis/user-signature-controller-api.mjs';
import '../core/apis/user-status-controller-api.mjs';
import '../core/apis/user-workplace-controller-api.mjs';
import '../core/apis/user-workspace-controller-api.mjs';
import '../core/apis/work-experience-action-controller-api.mjs';
import '../core/apis/work-experience-controller-api.mjs';
import '../core/apis/workplace-controller-api.mjs';
import '../core/apis/workplace-department-action-controller-api.mjs';
import '../core/apis/workplace-department-controller-api.mjs';
import '../core/apis/workplace-user-action-controller-api.mjs';
import '../core/apis/workplace-user-controller-api.mjs';

function useUpdateUserEmployeeBundlePermissionsRemote(requestParams, options) {
  return useQueryFromRemote({
    remote: updateUserEmployeeBundlePermissionsRemote,
    extraParams: requestParams,
    options
  });
}

export { useUpdateUserEmployeeBundlePermissionsRemote };
//# sourceMappingURL=useUpdateUserEmployeeBundlePermissionsRemote.mjs.map
